angular.module("avant.customer_applications.controllers").controller "DemoCtrl", [
  "$controller"
  "$cookieStore"
  "$interval"
  "$rootScope"
  "$sce"
  "$scope"
  "$timeout"
  "ApplicationService"
  "CustomerApplicationService"
  (
    $controller
    $cookieStore
    $interval
    $rootScope
    $sce
    $scope
    $timeout
    ApplicationService
    CustomerApplicationService
  ) ->
    # Current page/stage stubs
    $scope.page = "components"
    $scope.stageFromState = () => $scope.page
    $scope.isCurrentStage = (stage) => stage == $scope.page

    $scope.$emit("customer_application:data", ApplicationService.data)
    angular.extend(
      $scope,
      $controller(
        "CustomerApplicationsMixinCtrl"
        {
          $scope: $scope
          ApplicationService
          CustomerApplicationService
        }
      )
    )
    angular.extend($scope, $controller("SectionMixinCtrl", { $scope: $scope }))

    # Stubs for commonly used variables and methods
    $scope.inputs = {}
    $scope.loanOptionsHaveLoaded = () => true
    $scope.logoSrc = require("!!file-loader!@amount/frontend-styles/src/images/partners/amount_bank/logo/logo-amount_bank.svg")
    $scope.showPaymentMethod = () => true
    $scope.update = () => {}
    $scope.userAuthState = false
    $scope.userIsAuthenticated = () => $scope.userAuthState
    $scope.toggleUserAuthState = () =>
      $scope.userAuthState = !$scope.userAuthState
      $scope.$broadcast("customer:login", $scope.userAuthState)

    # Stubbed product for slider + text input, loan option row, loan breakdown, subheader
    $scope.select_loan = () => {}
    $scope.product =
      amount: 6000
      borrow_amount: 6000
      borrow_apr: 0.1999
      fdic_apr_percentage: 0.1999
      fl_doc_fee: 0
      interest_rate: 0.1999
      loan_processing_fee: 0
      loans: [
        {
          rate_option_id: 1
          term: 12
          monthly_payment: 555.78
          borrow_apr: 0.1999
          interest_rate: 0.1999
        }, {
          rate_option_id: 2
          term: 24
          monthly_payment: 305.35
          borrow_apr: 0.1999
          interest_rate: 0.1999
        }, {
          rate_option_id: 3
          term: 36
          monthly_payment: 222.95
          borrow_apr: 0.1999
          interest_rate: 0.1999
        }
      ]
      maximum_borrow_amount: 35000
      maximum_requestable_amount: 35000
      minimum_borrow_amount: 1000
      minimum_requestable_amount: 1000
      monthly_payment_display: 555.78
      monthly_payment: 555.78
      principal_amount: 6000
      requestable_loan_amounts: [2..70].map((n) => n * 500)
      requested_amount: 6000
      selected_loan: null
      term: 12
      total_origination_fees: 0

    # The amountProgressTracker directive needs product info broadcast to it
    # but because its link function isn't run until after this controller is
    # loaded, that broadcast needs to be delayed a bit.
    $timeout () =>
      $rootScope.$broadcast("product:data", $scope.product)
    100


    # Stubs for toggling FL doc fee in loan breakdown
    $scope.withFees = false
    $scope.toggleFees = () =>
      $scope.withFees = !$scope.withFees
      $scope.product.fl_doc_fee = if $scope.withFees then 120 else 0
      $scope.product.total_origination_fees = if $scope.withFees then 120 else 0
      $scope.product.principal_amount = if $scope.withFees then 6120 else 6000
      $scope.product.borrow_apr = if $scope.withFees then 0.2382 else 0.1999

    # Stubbed update and helper methods for slider, text input, and loan updates
    invalid = (value) =>
      val = parseInt(value)
      valTooLarge = val > $scope.product.maximum_requestable_amount
      valTooSmall = val < $scope.product.minimum_requestable_amount
      invalidInterval = val % 500 != 0
      valTooLarge || valTooSmall || invalidInterval
    updateLoans = (value) =>
      for loan in $scope.product.loans
        # To simulate interest on the monthly payments, subtract 1.1 from the
        # term (number of months) before dividing the loan amount by it
        # (the `.1` is to avoid round numbers to ensure values aren't being rounded).
        loan.monthly_payment = parseInt(value) / (parseInt(loan.term) - 1.1)
    updateInputsAndSliders = (value) =>
      for slider in $scope.sliders
        slider.value = value
      for textInput, idx in $scope.textInputs
        textInput.value = value
      $scope.product.requested_amount = value

    $scope.updateInputsAndLoans = (value) =>
      # Kill any existing timeouts to prevent multiple updates
      $timeout.cancel($scope.simulateUpdateApiCall)
      if invalid(value) then return
      $timeout () => $scope.updatingProduct = true
      $scope.simulateUpdateApiCall = $timeout(() =>
        updateInputsAndSliders(value)
        updateLoans(value)
        $scope.updatingProduct = false
      1000)

    # Wait for page to load before targeting elements to add listeners for
    # text input + slider components
    addListeners = (input, index) =>
      # We want the plain DOM elements so we can pass their value to the update
      # function, but we also need Angular (jqlite) elements so we can add
      # listeners to them.
      ngInput = angular.element(input)
      ngInput.on "change", () => $scope.updateInputsAndLoans(input.value)
      slider = $scope.sliders[index]
      ngSlider = angular.element(slider)
      ngSlider.on "change", () => $scope.updateInputsAndLoans(slider.value)
      # Set the initial manual value
      if (directiveScope = ngInput.scope())
        directiveScope.manualAmount = $scope.product.requested_amount

    i = 0
    inputs_check = $interval(
      () =>
        i += 1
        $scope.textInputs = Array.prototype.slice.call(document.querySelectorAll("amount_loan_amount_selector input[type=number]"))
        $scope.sliders = Array.prototype.slice.call(document.querySelectorAll("amount_loan_amount_selector input[type=range]"))

        if $scope.textInputs.length > 0 && $scope.sliders.length > 0
          for input, index in $scope.textInputs
            # The `do` block is necessary since we are using local variables
            # in the onChange callback functions. Without it those variables
            # would always have the values from the last iteration of the
            # `for`-loop every time the callback functions fire.
            do (input, index) ->
              addListeners(input, index)
          $interval.cancel(inputs_check)
        else if i > 50
          # Don't let interval run forever if the element isn't on the page
          $interval.cancel(inputs_check)
      100
    )

    # Method for disabling submit button
    $scope.tempDisable = () =>
      $scope.submitDisabled = true
      $timeout (() => $scope.submitDisabled = false), 1000

    # Method for displaying the full-page loading spinner
    $scope.openSpinnerBriefly = () =>
      $scope.openSpinner({ loadingMessage: "Customizable loading message" })
      $timeout $scope.closeSpinner, 2000

    $scope.displaySubHeader = () => true

    # Stubs for content page login form validity
    $scope.isFormValid = true
    $scope.hasFormError = (_form, _input) => !$scope.isFormValid
    $scope.toggleFormValidity = () => $scope.isFormValid = !$scope.isFormValid

    # Stubs for NOAA and contract iframe components
    $scope.viewNoaaUrl = $sce.trustAsResourceUrl "http://templatelab.com/wp-content/uploads/2019/02/adverse-action-notice-44.jpg"
    $scope.downloadNoaaUrl = $sce.trustAsResourceUrl "http://templatelab.com/wp-content/uploads/2019/02/adverse-action-notice-44.jpg"
    $scope.contracts = [{
      visible: true
      contract_path: $sce.trustAsResourceUrl "https://www.doctemplates.net/wp-content/uploads/2018/09/Sample-Loan-Agreement-Reverse-Mortgage-Loan.jpg"
    }]
    $scope.downloadContractPaths = [{
      download_contract_path: $sce.trustAsResourceUrl "https://www.doctemplates.net/wp-content/uploads/2018/09/Sample-Loan-Agreement-Reverse-Mortgage-Loan.jpg"
      link_text: "Download Direct Installment Loan Disclosure and Note"
    }]
    $scope.addAttributeToElements = () => {}

    # Stubs for decline page partner offers
    $scope.hasPartnerOffers = true
    $scope.declinedOptions = [
      {
        partnerImg: require('@amount/frontend-styles/src/images/logo/logo-avant.svg')
        partnerImgAltText: "Avant Logo"
        data: {
          partner_code: "avant_prefill_demo"
          partner_offer_id: 1
        }
      }
    ]
]
